define('modules/editor/models/property_groups/form_integration_correodirect',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:integration:correodirect",
    properties: ["active", "idaf", "fields"],
    editAllowed: false
  });
});

